import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { SessionValidityService } from '@core/auth/session-validator.service';

import { AlertModule } from '@shared/alert';

import { AuthGuardDirective } from './auth.directive';
import { AuthGuard } from './auth.guard';
import { AuthInterceptor } from './auth.interceptor';
import { AuthService } from './auth.service';
import { TENANT_CONFIG, tenantConfig } from './tenant.config';
import { MojoAuthorizationService } from '@core/auth/mojo-authorization.service';

const components = [AuthGuardDirective];

function handleAuthentication(authService: AuthService) {
  return () => authService.handleAuthentication();
}

function sessionValidityProcess(sv: SessionValidityService) {
  return () => sv.checkSessionValidity();
}

@NgModule({
  imports: [AlertModule],
  declarations: [...components],
  exports: [...components],
})
export class AuthModule {
  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthGuard,
        AuthService,
        MojoAuthorizationService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
          provide: APP_INITIALIZER,
          useFactory: handleAuthentication,
          deps: [AuthService],
          multi: true,
        },
        {
          provide: APP_INITIALIZER,
          useFactory: sessionValidityProcess,
          deps: [SessionValidityService],
          multi: true,
        },
        {
          provide: TENANT_CONFIG,
          useValue: tenantConfig,
        },
      ],
    };
  }
}
